import { Link } from "react-router-dom";

// `className` controls the rendered height (e.g. "h-[24px]"); width auto-scales
// so the official logo keeps its exact aspect ratio (never stretched/squashed).
export const Logo = ({ className = "h-[24px]" }) => (
  <Link to="/" data-testid="logo" className="inline-flex items-center leading-none select-none">
    <img src="/vision-logo.png" alt="Vision+" className={`w-auto ${className}`} />
  </Link>
);
